import React, { Component } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { Form, Grid } from 'semantic-ui-react'
import { validationAction } from './accions'

export class Callback extends Component {
    state = {
        _loading: true,
        _redirectTo: false,
        stepPath: '',
        banco: '',
        referral: ''
    }

    componentWillMount() {
        this.props.handleValidate({
            solicitudId: this.props.match.params.solicitudId
        })
        let banco = window.location.pathname.split('/')[1];
        if (banco === '/') {
            this.setState({ banco: 'credility' });
        } if (banco === 'callback') {
            this.setState({ banco: 'iaja', referral: 'Iaja' });
        } else {
            this.setState({ banco: banco, referral: banco.charAt(0).toUpperCase() + banco.slice(1) });
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            redirect
        } = nextProps;
        this.setState({
            stepPath: redirect,
            _redirectTo: true,
        })


    }

    render() {
        const {
            _loading,
            _redirectTo,
            stepPath,
            banco
        } = this.state

        const { redirect } = this.props
        if (_redirectTo) {
            if (stepPath === '/step99') {
                return <Redirect to={{ pathname: '/' + banco + '/greeting' }} />
            } else {
                return <Redirect to={{ pathname: `/${banco}${stepPath}` }} />
            }
        } else {
            if (redirect && redirect !== '') {
                if (redirect === '/step99') {
                    return <Redirect to={{ pathname: '/' + banco + '/greeting' }} />
                } else {
                    return <Redirect to={{ pathname: `/${banco}${redirect}` }} />
                }
            }
        }

        const textHead = 'Procesando, aguarde unos instantes.'

        return (
            <Grid centered>
                <Grid.Column mobile={14} tablet={10} computer={10}>
                    <h2>
                        {textHead}
                    </h2>
                    < br />
                    < br />
                    <Form loading={_loading}></Form>
                </Grid.Column>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => ({
    redirect: state.callbackReducer.stepRedirect,
    isLoggerdIn: state.callbackReducer.isLoggerdIn,
    referral: state.callbackReducer.referral
})

const mapDispatchToProps = (dispatch) => ({
    handleValidate: (payload) => dispatch(validationAction(payload))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Callback))



// WEBPACK FOOTER //
// ./src/conteiners/Callback/index.js